import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import {
  API_HUB_URL,
  BASE_URL,
  FECTH_AGENT,
  GAME_REPORT,
  GAME_REPORT_NIGHTLY,
  GAME_REPORT_REDIS,
  HIGH_VALUE_REPORT,
  GENERATE_EXCEL_INVOICE,
  GENERATE_PDF_INVOICE,
  INVOICE_REPORT,
  M_POST,
  PROVIDER_REPORT,
  PROVIDER_TYPE_REPORT,
  TRANSACTION_REPORT,
  WINLOSE_DOWNLOAD_REPORT_CSV,
  WINLOSE_LOG_ELASTIC,
  WINLOSE_LOG_ELASTIC_MECHANIC,
  WINLOSE_RANGE_DATE_REPORT_LOGS,
  WINLOSE_RANGE_DATE_REPORT_LOGS_MECHANIC,
  WINLOSE_REPORT,
  WINLOSE_REPORT_LOGS,
  WINLOSE_REPORT_MECHANIC,
  WINLOSE_REPORT_NEW,
  WINLOSE_REPORT_NIGHTLY,
  WINLOSE_ROUND_AMBSUPERGAME,
  FETCH_ROUND_ID,
  GAMES_SHEET,
  GAME_ANALYTICS_REPORT,
  GAME_SESSION_ANALYZE_REPORT
} from '@/utils/api';

@Module({ name: 'report', namespaced: true })
export default class Report extends VuexModule {
  dataWinLose: any = {};

  dataWinLoseLog: any = {};

  dataNewWinLoseLog: any = {};

  dataGame: any = [];

  dataInvoice: any = {};

  dataFile: any = {};

  dataCSV: Blob | null = null;

  // ===== Win/Lose =====
  @Mutation
  mutateWinLose(payload: any) {
    this.dataWinLose = payload;
  }

  @Action({ commit: 'mutateWinLose', rawError: true })
  async FetchWinLose(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + WINLOSE_REPORT,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch win/lose failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch win/lose failed');
    }
  }

  @Mutation
  mutateWinLoseLog(payload: any) {
    this.dataWinLoseLog = payload.dataWinLoseLog;
  }

  @Mutation
  mutateNewWinLose(payload: any) {
    this.dataNewWinLoseLog = payload;
  }

  @Action({ commit: 'mutateWinLose', rawError: true })
  async FetchNewWinLose(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + WINLOSE_REPORT_NEW,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch new win/lose failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch new win/lose failed');
    }
  }

  @Action({ commit: 'mutateWinLose', rawError: true })
  async FetchHighValueReport(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + HIGH_VALUE_REPORT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch high value report failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch high value report failed');
    }
  }

  @Action({ commit: 'mutateWinLose', rawError: true })
  async FetchNewWinLoseNightly(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + WINLOSE_REPORT_NIGHTLY,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch new win/lose nightly failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch new win/lose nightly failed');
    }
  }

  @Action({ commit: 'mutateNewWinLose', rawError: true })
  async FetchWinLoseRangeLog(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + WINLOSE_RANGE_DATE_REPORT_LOGS,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch win/lose range log failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch win/lose range log failed');
    }
  }

  @Action({ commit: 'mutateNewWinLose', rawError: true })
  async FetchRoundId(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + FETCH_ROUND_ID,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch round id failed');
      return { ...(data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch round id failed');
    }
  }

  @Action({ commit: 'mutateNewWinLose', rawError: true })
  async FetchWinloseLogElastic(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + WINLOSE_LOG_ELASTIC,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch win/lose elastic log failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch win/lose elastic log failed');
    }
  }

  // ===== WIN_LOSE_MECHANIC =====
  @Action({ commit: 'mutateWinLose', rawError: true })
  async FetchNewWinLoseMechanic(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + WINLOSE_REPORT_MECHANIC,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch new win/lose mechanic failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch new win/lose mechanic failed');
    }
  }

  @Action({ commit: 'mutateWinLoseLog', rawError: true })
  async FetchWinLoseLogMechanic(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + WINLOSE_REPORT_LOGS,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch win/lose logs failed');

      const reportLog = Array.isArray(data?.data?.reportLog) ? data.data.reportLog : [];
      reportLog.sort((a: any, b: any) => String(b.timestamp).localeCompare(String(a.timestamp)));

      return {
        dataWinLoseLog: reportLog,
        breadcrumb: data?.data?.breadcrumb,
        paginationDetail: data?.data?.paginationDetail,
        footerSummaryLog: data?.data?.footerSummaryLog,
        totaldata: data?.data?.reportCount
      };
    } catch (err: any) {
      throw toError(err, 'Fetch win/lose logs failed');
    }
  }

  @Action({ commit: 'mutateNewWinLose', rawError: true })
  async FetchWinLoseRangeLogMechanic(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + WINLOSE_RANGE_DATE_REPORT_LOGS_MECHANIC,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch win/lose range log mechanic failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch win/lose range log mechanic failed');
    }
  }

  @Action({ commit: 'mutateNewWinLose', rawError: true })
  async FetchWinloseLogElasticMechanic(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + WINLOSE_LOG_ELASTIC_MECHANIC,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch win/lose elastic log mechanic failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch win/lose elastic log mechanic failed');
    }
  }

  @Action({ rawError: true })
  async FetchResultAmbSuperGame(params: any) {
    try {
      const { data } = await axios({
        url: API_HUB_URL + WINLOSE_ROUND_AMBSUPERGAME,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch amb supergame result failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch amb supergame result failed');
    }
  }

  // ===== Game Report =====
  @Mutation
  mutateGameReport(payload: any) {
    this.dataGame = payload;
  }

  @Action({ commit: 'mutateGameReport', rawError: true })
  async FetchGameReport(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + GAME_REPORT,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch game report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch game report failed');
    }
  }

  @Action({ commit: 'mutateGameReport', rawError: true })
  async FetchGameReportNightly(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + GAME_REPORT_NIGHTLY,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch game report nightly failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch game report nightly failed');
    }
  }

  @Action({ commit: 'mutateGameReport', rawError: true })
  async FetchGameReportWithRedis(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + GAME_REPORT_REDIS,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch game report redis failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch game report redis failed');
    }
  }

  // ===== Provider / Transaction / Agent =====
  @Action({ rawError: true })
  async FetchProviderReport(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + PROVIDER_REPORT,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch provider report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch provider report failed');
    }
  }

  @Action({ rawError: true })
  async FetchProviderReportByType(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + PROVIDER_TYPE_REPORT,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch provider type report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch provider type report failed');
    }
  }

  @Action({ rawError: true })
  async FetchTransaction(params: any) {
    try {
      const { data } = await axios({
        url: BASE_URL + TRANSACTION_REPORT,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch transaction report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch transaction report failed');
    }
  }

  @Action({ rawError: true })
  async FetchAgent(params: any) {
    try {
      const { data } = await axios({
        url: BASE_URL + FECTH_AGENT,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch agent failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch agent failed');
    }
  }

  // ===== Invoice =====
  @Mutation
  mutateInvoice(payload: any) {
    this.dataInvoice = payload;
  }

  @Action({ commit: 'mutateInvoice', rawError: true })
  async FetchInvoice(criteria: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + INVOICE_REPORT,
        data: criteria,
        method: M_POST
      });

      assertOk(data, 'Fetch invoice failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch invoice failed');
    }
  }

  @Mutation
  mutateFileExcel(payload: any) {
    this.dataFile = payload;
  }

  @Action({ commit: 'mutateFileExcel', rawError: true })
  async generateFileExcel(dataInvoice: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + GENERATE_EXCEL_INVOICE,
        responseType: 'blob',
        data: dataInvoice,
        method: M_POST
      });

      return { dataFile: data };
    } catch (err: any) {
      throw toError(err, 'Generate excel invoice failed');
    }
  }

  @Mutation
  mutateFilePdf(payload: any) {
    this.dataFile = payload;
  }

  @Action({ commit: 'mutateFilePdf', rawError: true })
  async generateFilePdf(dataInvoice: object) {
    try {
      const { data } = await axios({
        url: BASE_URL + GENERATE_PDF_INVOICE,
        responseType: 'blob',
        data: dataInvoice,
        method: M_POST
      });

      return { dataFile: data };
    } catch (err: any) {
      throw toError(err, 'Generate pdf invoice failed');
    }
  }

  // ===== CSV Download =====
  @Mutation
  mutateCSVReport(data: Blob) {
    this.dataCSV = data;
  }

  @Action
  async FetchCSVReport(params: any) {
    try {
      const resp = await axios({
        url: BASE_URL + WINLOSE_DOWNLOAD_REPORT_CSV,
        method: M_POST,
        responseType: 'blob',
        params: { rate: params?.rate },
        data: params?.criteria,
        headers: {
          'Content-Type': 'application/json'
        }
      } as any);

      const blob = resp?.data as Blob;

      const contentType = String(resp?.headers?.['content-type'] ?? '').toLowerCase();
      if (contentType.includes('application/json')) {
        const text = await blob.text();
        let msg = 'Export failed';
        try {
          const json = JSON.parse(text);
          msg = json?.status?.message || json?.message || json?.msg || msg;
          throw toError({ response: { data: json } }, msg);
        } catch (_e) {
          throw toError({ response: { data: { message: msg } } }, msg);
        }
      }

      return blob;
    } catch (err) {
      throw toError(err, 'Export failed');
    }
  }

  @Action
  async GamesDownloadSheet(params: Record<string, any> = {}) {
    try {
      const resp = await axios({
        url: BASE_URL + GAMES_SHEET,
        data: params,
        method: M_POST,
        responseType: 'blob'
      } as any);

      const blob = resp?.data as Blob;

      const contentType = String(resp?.headers?.['content-type'] ?? '').toLowerCase();
      if (contentType.includes('application/json')) {
        const text = await blob.text();
        let msg = 'Export failed';
        try {
          const json = JSON.parse(text);
          msg = json?.status?.message || json?.message || json?.msg || msg;
          throw toError({ response: { data: json } }, msg);
        } catch (_e) {
          throw toError({ response: { data: { message: msg } } }, msg);
        }
      }

      return blob;
    } catch (err) {
      throw toError(err, 'Export failed');
    }
  }

  @Action({ commit: 'gameAnalytics', rawError: true })
  async FetchGameAnalytics(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + GAME_ANALYTICS_REPORT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch game analytics failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch game analytics failed');
    }
  }

  @Action({ rawError: true })
  async FetchGameSessionAnalyze(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + GAME_SESSION_ANALYZE_REPORT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch game session analyze failed');
      return data;
    } catch (err: any) {
      throw toError(err, 'Fetch game session analyze failed');
    }
  }
}
